import Link from "next/link";
import React, { useState } from "react";

function Accordion({ title, content }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleRotate = () => {
    return isOpen ? "rotate-180" : "";
  };

  const handleToggle = () => {
    return isOpen ? "max-h-full" : "max-h-0";
  };

  return (
    <li className="bg-white border border-gray-200 shadow rounded-md relative items-center justify-center mb-2 text-slate-900">
      <h2
        onClick={handleClick}
        className="flex justify-between items-center font-semibold p-3 cursor-pointer"
      >
        <span className="flex basis-11/12">{title}</span>
        <svg
          className={`fill-current basis-1/12 text-[#FF5744] h-6 w-6 transform transition-transform ${handleRotate()}`}
          viewBox="0 0 20 20"
        >
          <path d="M13.962,8.885l-3.736,3.739c-0.086,0.086-0.201,0.13-0.314,0.13S9.686,12.71,9.6,12.624l-3.562-3.56C5.863,8.892,5.863,8.611,6.036,8.438c0.175-0.173,0.454-0.173,0.626,0l3.25,3.247l3.426-3.424c0.173-0.172,0.451-0.172,0.624,0C14.137,8.434,14.137,8.712,13.962,8.885 M18.406,10c0,4.644-3.763,8.406-8.406,8.406S1.594,14.644,1.594,10S5.356,1.594,10,1.594S18.406,5.356,18.406,10 M17.521,10c0-4.148-3.373-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.148,17.521,17.521,14.147,17.521,10"></path>
        </svg>
      </h2>
      <div
        className={`border-l-2 border-[#FF5744] overflow-hidden transition-all ${handleToggle()}`}
      >
        <p className="p-3 text-gray-900">{content}</p>
      </div>
    </li>
  );
}

export default function FAQ() {
  return (
    <main className="text-slate-900 mb-10" id="faq">
      <div className="flex justify-center items-start">
        <div className="w-full">
          <h2 className="text-[26px] leading-8 font-bold mb-5 text-center">
            Häufige Fragen
          </h2>
          <ul className="flex flex-col">
            <Accordion
              title="Wann erhalte ich die Sofortbildkamera(s) + Bilder"
              content={
                <>
                  Du erhältst die Sofortbildkamera(s) + Bilder{" "}
                  <strong>garantiert 1-3 Tage</strong> vor deinem Miettag.
                </>
              }
            />
            <Accordion
              title="Wann muss ich die Sofortbildkamera(s) zurücksenden?"
              content={
                <>
                  Du sendest die Sofortbildkamera(s) nach deinem Miettag, am{" "}
                  <strong>nächsten Werktag</strong>, zurück. Ist dein Miettag
                  z.B. ein Samstag, sendest du die Sofortbildkamera(s) am Montag
                  zurück.
                </>
              }
            />
            <Accordion
              title="Wie läuft der Rückversand ab?"
              content={
                <>
                  Den <strong>vorfrankierten Rücksendeschein</strong> bekommst
                  du mit der Versandbestätigung per E-Mail. Pack alles ein,
                  drucke den Schein aus, klebe ihn auf das Paket und gib es in
                  einem DPD Paketshop ab. Fertig!
                </>
              }
            />
            <Accordion
              title="Wie viele Bilder benötige ich?"
              content={
                <>
                  Diese Frage lässt sich nicht pauschal beantworten, da jeder
                  Anlass individuell gefeiert wird. Wenn beispielsweise eine
                  Sofortbildkamera für ein Hochzeits-Gästebuch verwendet wird,
                  empfehlen wir, so viele Bilder zu nehmen, wie Gäste erwartet
                  werden. Auf diese Weise seid ihr in der Regel gut
                  ausgestattet. Nicht genutzte Bilder (nur geschlossene
                  Packungen – in einer Packung sind 2x Filme mit jeweils 10
                  Bilder) kannst du mit zurücksenden. Du erhältst dann eine
                  Erstattung.
                </>
              }
            />
            <Accordion
              title="Kann ich nicht genutzte Bilder/Filme zurücksenden?"
              content={
                <>
                  Ja, nicht genutzte Bilder (nur geschlossene Packungen – in
                  einer Packung sind 2x Filme mit jeweils 10 Bilder) kannst du
                  mit zurücksenden. Du erhältst dann eine Erstattung.
                </>
              }
            />

            <Accordion
              title="Wie unterscheiden sich Instax Mini 12 und Instax Mini Evo?"
              content={
                <>
                  Die <strong>Instax Mini 12</strong> ist eine kompakte und
                  einfache Sofortbildkamera die jedes Bild direkt als Polaroid
                  ausdruckt.
                  <br />
                  <br />
                  Die <strong>Instax Mini Evo</strong> speichert alle Bilder
                  digital auf einer Micro SD-Karte ab. Du kannst auswählen,
                  welches Bild als Polaroidbild gedruckt werden soll. Auch
                  kannst du dein Handy mit der Kamera verbinden und somit Bilder
                  vom Handy über die Kamera als Polaroidbild ausdrucken.
                  Außerdem hat die Instax Mini Evo bis zu 100 verschiedene
                  Filter.
                </>
              }
            />
            <Accordion
              title="Du benötigst mehr als 5 Sofortbild-Kameras?"
              content={
                <>
                  Schreibe uns an{" "}
                  <Link
                    className="underline hover:no-underline"
                    href="mailto:hallo@fotoboxguru.de"
                  >
                    hallo@fotoboxguru.de
                  </Link>{" "}
                  und wir können die Verfügbarkeiten für dich prüfen.
                </>
              }
            />
            <Accordion
              title="Du hast noch Fragen?"
              content={
                <>
                  Schreibe uns einfach eine E-Mail an{" "}
                  <Link
                    className="underline hover:no-underline"
                    href="mailto:hallo@fotoboxguru.de"
                  >
                    hallo@fotoboxguru.de
                  </Link>
                  .
                </>
              }
            />
          </ul>
        </div>
      </div>
    </main>
  );
}
